"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useQuickClientAsync = useQuickClientAsync;
const react_1 = require("react");
const asyncRunCache = {};
const asyncResultCache = {};
function useQuickClientAsync(id, run) {
    const [ord, setOrd] = (0, react_1.useState)(0);
    const meta = (0, react_1.useRef)({ watching: false });
    if (asyncResultCache[id]?.finished) {
        return asyncResultCache[id];
    }
    if (!meta.current.watching) {
        if (!asyncRunCache[id]) {
            asyncRunCache[id] = run().then((result) => {
                asyncResultCache[id] = {
                    result,
                    finished: true,
                };
                setOrd(ord + 1);
                return result;
            });
        }
        else {
            asyncRunCache[id].then(() => {
                setOrd(ord + 1);
            });
        }
        meta.current.watching = true;
    }
    return {
        finished: false,
        result: null,
    };
}
